import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { ZXingScannerModule } from '@zxing/ngx-scanner';

import {
    PoPageModule,
    PoFieldModule,
    PoWidgetModule,
    PoButtonModule,
} from '@po-ui/ng-components';

import { BarcodeFormat } from '@zxing/library';
import { ProductService } from '../../shared/service/product.service';
import { TokenService } from '../../shared/service/token.service';
import { ToasterService } from '../../shared/service/toaster.service';
import { ToasterComponent } from '../../shared/components/toaster/toaster.component';

@Component({
    selector: 'app-batch-item-details',
    templateUrl: './batch-item-details.component.html',
    styleUrls: ['./batch-item-details.component.css'],
    standalone: true,
    imports: [
        CommonModule,
        FormsModule,
        ZXingScannerModule,
        PoPageModule,
        PoFieldModule,
        PoButtonModule,
        PoWidgetModule,
        ToasterComponent
    ]
})
export class BatchItemDetailsComponent implements OnInit {
    barcode = '';
    scannerVisible = false;
    selectedDevice?: MediaDeviceInfo;
    formatsEnabled: BarcodeFormat[] = [
        BarcodeFormat.CODE_128,
        BarcodeFormat.EAN_13,
        BarcodeFormat.EAN_8,
        BarcodeFormat.CODE_39,
        BarcodeFormat.ITF
    ];

    itemData: any = null;

    constructor(
        private productService: ProductService,
        private tokenService: TokenService,
        private toasterService: ToasterService
    ) { }

    ngOnInit(): void {
        navigator.mediaDevices.enumerateDevices().then(devices => {
            const videoDevices = devices.filter(d => d.kind === 'videoinput');
            if (videoDevices.length > 0) {
                this.selectedDevice = videoDevices[0];
            }
        });
    }

    toggleScanner(): void {
        this.scannerVisible = !this.scannerVisible;
    }

    onBarcodeScanned(code: string): void {
        this.scannerVisible = false;
        this.barcode = code;
        this.fetchItemData();
    }

    fetchItemData(): void {
        const branch = Number(this.tokenService.getBranch());

        this.productService.searchBatchItem(branch, '', this.barcode).subscribe({
            next: (res) => {
                const item = res?.items?.[0];
                if (!item) {
                    this.toasterService.triggerAlert('Item não encontrado.', 'warning');
                    this.itemData = null;
                    return;
                }

                this.itemData = {
                    company: item.branchCode,
                    batch: item.batchCode,
                    item: item.sequence,
                    product: `${item.productCode} - ${item.productName}`,
                    barcode: item.itemClient,
                    quantity: item.quantityItem,
                    pending: (item.quantityItem ?? 0) - (item.quantityIssued ?? 0),
                    location: item.locationCode ?? 'Não informado',
                    balanceType: item.stockDescription ?? 'Não informado',
                    orderRelation: item.salesOrders?.length > 0
                        ? item.salesOrders.map((o: any) =>
                            `${o.branchCode}/${o.orderCode} (${this.getSalesOrderStatusLabel(o.status)})`
                        ).join(', ')
                        : 'Não vinculado',
                    transactionRelation: item.transactions?.length > 0
                        ? item.transactions.map((t: any) =>
                            `${t.transactionDate} / ${t.transactionCode} (${this.getTransactionStatusLabel(t.status)})`
                        ).join(', ')
                        : 'Sem transações'
                };
            },
            error: () => {
                this.toasterService.triggerAlert('Erro ao buscar dados do item.', 'error');
                this.itemData = null;
            }
        });
    }


    getTransactionStatusLabel(status: number): string {
        switch (status) {
            case 1: return 'Em andamento';
            case 2: return 'Liberado para faturamento';
            case 3: return 'Parcialmente atendida';
            case 4: return 'Atendida';
            case 5: return 'Encerrada';
            case 6: return 'Cancelada';
            case 7: return 'Pré-faturada';
            case 8: return 'Bloqueada p/ faturamento';
            case 9: return 'Recusada';
            case 10: return 'Agrupada';
            default: return 'Desconhecido';
        }
    }

    getSalesOrderStatusLabel(status: number): string {
        switch (status) {
            case 1: return 'Em andamento';
            case 2: return 'Liberado para faturamento';
            case 3: return 'Parcialmente recebido';
            case 4: return 'Atendido';
            case 5: return 'Bloqueado';
            case 6: return 'Cancelado';
            case 7: return 'Em composição';
            case 8: return 'Em análise';
            default: return 'Desconhecido';
        }
    }

    onClear(): void {
        this.barcode = '';
        this.itemData = null;
        this.scannerVisible = false;

        setTimeout(() => {
            const input = document.querySelector('input[name="itemBarcode"]') as HTMLInputElement;
            if (input) input.focus();
        }, 300);
    }


}
